import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Grid, Card, CardActionArea, CardContent, Stack, Chip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export default function Home() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="h4" textAlign="center">Flows</Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Select a flow to view details. You can add more flows here later.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined">
            <CardActionArea component={Link} to="/workflows/amd">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <DashboardIcon color="primary" />
                  <Typography variant="h6">Tymeline AMD Project Management Workflow</Typography>
                  <Chip label="New" color="primary" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  Project setup, execution, approvals, and data integrations.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined">
            <CardActionArea component={Link} to="/availability">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <CalendarMonthIcon color="primary" />
                  <Typography variant="h6">Team Availability Timeline</Typography>
                  <Chip label="Beta" color="secondary" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  View members' availability with a day-by-day timeline and weekend highlighting.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined">
            <CardActionArea component={Link} to="/workflows/voice-chat">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <RecordVoiceOverIcon color="primary" />
                  <Typography variant="h6">Voice Chat Flow (WebSocket)</Typography>
                  <Chip label="New" color="primary" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  WebRTC-based live voice chatting workflow with WebSocket signaling.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined">
            <CardActionArea component={Link} to="/workflows/voice-chat-rest">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <RecordVoiceOverIcon color="primary" />
                  <Typography variant="h6">Voice Chat Flow (REST)</Typography>
                  <Chip label="New" color="secondary" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  REST-based voice chat workflow with polling mechanism visualization.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined">
            <CardActionArea component={Link} to="/workflows/ai-employee">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <SmartToyIcon color="primary" />
                  <Typography variant="h6">AI Employee Workflow</Typography>
                  <Chip label="New" color="info" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  Lifecycle of AI Employees: creation, assignment, execution, and reinforcement.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Card variant="outlined" sx={{ borderColor: 'primary.main' }}>
            <CardActionArea component={Link} to="/workflows/ai-employee-diagrams">
              <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                  <AccountTreeIcon color="primary" />
                  <Typography variant="h6">AI Employee Product Diagrams</Typography>
                  <Chip label="New" color="success" size="small" sx={{ ml: 'auto' }} />
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  Visual architecture diagrams: task execution, reinforcement loop, audit trail, chat, and more.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}


